module.exports = __webpack_public_path__ + "img/pretty-waves.a1d8c5d0.png";